<script setup>
import { computed, shallowRef } from "vue";

import { projects as projectsApi } from "~/api";
import GlAlert from "~/components/gitlab/GlAlert.vue";
import GlModal from "~/components/gitlab/GlModal.vue";
import { fetch } from "~/utils/api";

const { projectId, projectName } = defineProps({
  projectId: {
    required: true,
    type: [String, Number]
  },
  projectName: {
    default: "this project",
    type: String
  }
});

const emit = defineEmits(["close", "done"]);

const submitting = shallowRef(false);
const alert = shallowRef(null);

const actionPrimary = computed(() => ({
  attributes: {
    category: "primary",
    disabled: submitting.value,
    variant: "danger"
  },
  text: submitting.value ? "Deleting…" : "Delete"
}));

const actionCancel = { text: "Cancel" };

async function onPrimary(event) {
  event.preventDefault();
  submitting.value = true;
  alert.value = null;

  await fetch({
    alert,
    apiMethod: projectsApi.destroy,
    onError: () => {
      submitting.value = false;
    },
    onSuccess: (data) => {
      alert.value = { message: data.message, type: data.type };
      if (data.type === "success") emit("done");
    },
    requestArgs: { params: { id: projectId } }
  });
}
</script>

<template>
  <GlModal
    modal-id="delete-project-modal"
    title="Delete project"
    :visible="true"
    :action-primary="actionPrimary"
    :action-cancel="actionCancel"
    @primary="onPrimary"
    @canceled="emit('close')"
    @change="
      (v) => {
        if (!v) emit('close');
      }
    "
  >
    <GlAlert v-if="alert" :variant="alert.type" class="mb-4" @dismiss="alert = null">
      {{ alert.message }}
    </GlAlert>
    <p class="text-sm text-[var(--gl-text-color-default)]">
      Are you sure you want to delete
      <strong class="text-[var(--gl-text-color-strong)]">{{ projectName }}</strong
      >? This action cannot be undone.
    </p>
  </GlModal>
</template>
